import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import AdditionalLicensesNCertificates from '../AdditionalLicensesNCertificates';
import ContinuingMedicalEducationCertificates from '../ContinuingMedicalEducationCertificates';
import ControlledSubstanceCertification from '../ControlledSubstanceCertification';
import { IAdditionalLicense } from 'types/newUniprofile';
import { providerLicenseBatchByType } from 'api/provider';

interface Props {
    initValue?: IAdditionalLicense;
    isEditing?: boolean;
    refetch?: () => void;
    scheduleToken?: string;
}

const AdditionalLicense = forwardRef((props: Props, ref) => {
    const { initValue, isEditing, refetch, scheduleToken } = props;
    const CSCRef = useRef<any>(null);
    const CMECRef = useRef<any>(null);

    const onSubmit = async () => {
        try {
            const [CSCList, CMECList] = await Promise.all([CSCRef.current?.getValues(), CMECRef.current?.getValues()]);
            await Promise.all([
                providerLicenseBatchByType(CSCList, 'CSC', scheduleToken),
                providerLicenseBatchByType(CMECList, 'CMEC', scheduleToken),
            ]);
            refetch?.();
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    return (
        <>
            <ControlledSubstanceCertification
                isEditing={isEditing}
                initValue={initValue?.controlledSubstanceCertification}
                ref={CSCRef}
            />
            <ContinuingMedicalEducationCertificates
                isEditing={isEditing}
                initValue={initValue?.continuingMedicalEducationCertificates}
                ref={CMECRef}
            />
            <AdditionalLicensesNCertificates
                isEditing={isEditing}
                initValue={{
                    autonomy: initValue?.autonomy,
                    other: initValue?.other,
                }}
                refetch={refetch}
            />
        </>
    );
});

export default AdditionalLicense;
